import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationService } from './services/localization.service';
import { MissingTranslationHandler as NgxMissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { MissingTranslationHandler } from './missing-translation-handler';
import { TranslationImportService } from './services/translation-import.service';
import { HttpModule } from '@angular/http';

@NgModule({
    imports: [
        CommonModule,
        // BootstrapModule,
        TranslateModule.forRoot({
            missingTranslationHandler: {
                provide: NgxMissingTranslationHandler,
                useClass: MissingTranslationHandler,
                deps: [],
            },
        }),
        HttpModule
    ],
    declarations: [],
    providers: [
        LocalizationService,
        TranslationImportService,
    ],
    exports: [
        TranslateModule
    ],
})
export class ChassisLocalizationModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: ChassisLocalizationModule,
            providers: [
                LocalizationService,
                TranslationImportService,
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-localization/src/chassis-localization.module.ts